import React from "react";
import {
    createStyles,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";

type LiveClosedNoticeProps = WithStyles<typeof styles> & {
    auctionLive: boolean;
    auctionClosed: boolean;
    shortForm?: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        formSection: { marginBottom: theme.spacing(5) },
        notice: {
            alignItems: "center",
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            minHeight: 70,
            padding: theme.spacing(2),
            width: "100%"
        },
        noticeClosed: {
            backgroundColor: theme.palette.primary.light,
            border: `1px solid ${theme.palette.primary.main}`
        },
        noticeLive: {
            backgroundColor: theme.palette.success.light,
            border: `1px solid ${theme.palette.success.main}`
        }
    });

class LiveClosedNotice extends React.PureComponent<LiveClosedNoticeProps, {}> {
    public render() {
        const classes = this.props.classes;

        return (
            <>
                {/* Live Notice */}
                {this.props.auctionLive && (
                    <div
                        className={`${classes.formSection} ${classes.notice} ${classes.noticeLive}`}
                    >
                        <Warning />
                        <Typography
                            component="span"
                            variant="body2"
                            display="inline"
                            color="inherit"
                        >
                            &nbsp;This sale is currently live.{" "}
                            {!this.props.shortForm &&
                                "Most fields on this page are disabled until the sale is closed."}
                        </Typography>
                    </div>
                )}

                {/* Closed Notice */}
                {this.props.auctionClosed && (
                    <div
                        className={`${classes.formSection} ${classes.notice} ${classes.noticeClosed}`}
                    >
                        <Warning />
                        <Typography
                            component="span"
                            variant="body2"
                            display="inline"
                            color="inherit"
                        >
                            &nbsp;This sale is now closed.{" "}
                            {!this.props.shortForm &&
                                "Parcel creation and sale fields (name, amount, dates, URL) will be disabled."}
                        </Typography>
                    </div>
                )}
            </>
        );
    }
}

export default withStyles(styles)(LiveClosedNotice);
